import { FunctionComponent, ReactNode } from 'react'
import { Box } from '@mui/material'
import { Check, Clear } from '@mui/icons-material'

type Props = {
  error: boolean
  children?: ReactNode
}

const PasswordRequirement: FunctionComponent<Props> = ({ error, children }) => {
  const Icon = error ? Clear : Check
  return (
    <Box display="flex" alignItems="center" sx={{ color: error ? 'inherit' : 'success.600' }}>
      <Icon sx={{ fontSize: '1em' }} />
      <Box ml={1} component="span">
        {children}
      </Box>
    </Box>
  )
}

export default PasswordRequirement
